import client from "./clients/portalClient";

const getAllNawContacts = (cat) => client.get(`/contacts?data=${cat}`);
const getNawContact = (id) => client.get(`/contacts/${id}`);
const getNawContactHistory = (id) => client.get(`/contacts/${id}/history`);
const PostNewNawContact = (data) => client.post(`/contacts`, data);
const editNawContact = (id,data) => client.put(`/contacts/${id}`, data);
const deleteNawContact = (id) => client.delete(`/contacts/${id}`);


const nawContactsApi = {
  getAllNawContacts,
  getNawContact,
  getNawContactHistory,
  PostNewNawContact,
  editNawContact,
  deleteNawContact
};

export default nawContactsApi;
